import AppDispatcher from '../../core/AppDispatcher'
import ReservationEvent from '../../event/ReservationEvent'

const onEdit = event => {
  AppDispatcher.dispatchWithType(ReservationEvent.onEdit, {
    name: event.target.name,
    value: event.target.value
  })

  return true
}

export default onEdit
